import React from 'react'

export default function HotelLoader(props) {

  const createHtml = (msg) => {
    return {__html: msg}
  }
  return (
    <div className="text-center p-5 m-5">
        <div className="top-100">
            <div className="mt-5 form-holder pt-3">
            <div className="loader-css"></div>
            <p></p>
            <h5 className="fw-sbold pb-5" dangerouslySetInnerHTML={createHtml(props.msg)}>
            </h5>
            </div>
        </div>
    </div>
  )
}
